// components/estimates/EstimateLeadPromoCard.js
// Card con selezione lead, promozione e tempi consegna

import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Calendar, Tag } from 'lucide-react';

const EstimateLeadPromoCard = ({
  isNew,
  formData,
  setFormData,
  leads,
  promotions,
  onPromotionChange,
  getLeadName
}) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {isNew ? (
            <div className="space-y-2">
              <Label className="flex items-center gap-2 h-5">
                Lead <span className="text-red-500">*</span>
              </Label>
              <Select
                value={formData.lead_id}
                onValueChange={(value) => setFormData(prev => ({ ...prev, lead_id: value }))}
              >
                <SelectTrigger data-testid="lead-select">
                  <SelectValue placeholder="Seleziona lead" />
                </SelectTrigger>
                <SelectContent>
                  {leads.map(lead => (
                    <SelectItem key={lead.id} value={lead.id}>
                      {lead.first_name} {lead.last_name} - {lead.property_address}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          ) : (
            <div className="space-y-2">
              <Label className="flex items-center gap-2 h-5">Lead</Label>
              <div className="h-10 flex items-center font-medium text-[#3C3C3C] bg-gray-50 px-3 rounded-md border border-gray-200">
                {getLeadName(formData.lead_id)}
              </div>
            </div>
          )}
          <div className="space-y-2">
            <Label className="flex items-center gap-2 h-5">
              <Tag className="w-4 h-4" />
              Promozione
            </Label>
            <Select
              value={formData.promotion_id || ''}
              onValueChange={onPromotionChange}
            >
              <SelectTrigger data-testid="promotion-select">
                <SelectValue placeholder="Seleziona promozione" />
              </SelectTrigger>
              <SelectContent>
                {promotions.map(promo => (
                  <SelectItem key={promo.id} value={promo.id}>
                    {promo.name} {promo.discount_percentage > 0 && `(-${promo.discount_percentage}%)`}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {formData.promotion_discount_percentage > 0 && (
              <p className="text-sm text-[#FF7819] mt-1">
                Sconto {formData.promotion_discount_percentage}% applicato sul totale investimento
              </p>
            )}
          </div>
          <div className="space-y-2">
            <Label className="flex items-center gap-2 h-5">
              <Calendar className="w-4 h-4" />
              Tempi di consegna (gg lavorativi)
            </Label>
            <Input
              type="number"
              min="0"
              placeholder="Es. 120"
              value={formData.delivery_days || ''}
              onChange={(e) => setFormData(prev => ({ 
                ...prev, 
                delivery_days: e.target.value ? parseInt(e.target.value) : null 
              }))}
              data-testid="delivery-days-input"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EstimateLeadPromoCard;
